import { render, staticRenderFns } from "./pollPage.vue?vue&type=template&id=04335530&"
import script from "./pollPage.vue?vue&type=script&lang=ts&"
export * from "./pollPage.vue?vue&type=script&lang=ts&"
import style0 from "./pollPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports